import { useQuery } from '@tanstack/react-query';
import { http } from './http';
import type { DamageReportPayload, DamageVehicles, VehicleDamage } from '../types';

// Dégâts des véhicules de l'école : le moniteur signale un dégât repéré (photos à l'appui), vérifie ceux
// déjà connus d'un véhicule et suit ses propres signalements.

export const vehicleDamagesApi = {
  async vehicles(): Promise<DamageVehicles> {
    return (await http.get<DamageVehicles>('/v1/instructor/me/vehicle-damages/vehicles')).data;
  },
  async known(vehicleId: string): Promise<VehicleDamage[]> {
    return (await http.get<VehicleDamage[]>(`/v1/instructor/me/vehicle-damages/vehicles/${vehicleId}`)).data;
  },
  async mine(): Promise<VehicleDamage[]> {
    return (await http.get<VehicleDamage[]>('/v1/instructor/me/vehicle-damages')).data;
  },
  async report(payload: DamageReportPayload): Promise<VehicleDamage> {
    const form = new FormData();
    form.append('vehicleId', payload.vehicleId);
    form.append('moment', payload.moment);
    form.append('area', payload.area);
    form.append('description', payload.description.trim());
    form.append('drivable', String(payload.drivable));
    if (payload.mileage?.trim()) form.append('mileage', payload.mileage.trim());
    payload.photos.forEach((photo, index) =>
      form.append('photos', photo, `degat-${index + 1}.${photo.type === 'image/jpeg' ? 'jpg' : (photo.type.split('/')[1] ?? 'jpg')}`),
    );
    const { data } = await http.post<VehicleDamage>('/v1/instructor/me/vehicle-damages', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
};

/** L'école gère-t-elle ses véhicules dans Permio ? Rubrique « Véhicules » et raccourci de la journée sinon masqués. */
export function useVehicleDamagesEnabled(): boolean {
  const { data } = useQuery({ queryKey: DAMAGE_KEYS.vehicles, queryFn: vehicleDamagesApi.vehicles, staleTime: 5 * 60_000, retry: false });
  return data?.enabled === true;
}

/** Clés des requêtes : rafraîchies après un signalement. */
export const DAMAGE_KEYS = {
  vehicles: ['vehicle-damages', 'vehicles'] as const,
  known: (vehicleId: string) => ['vehicle-damages', 'known', vehicleId] as const,
  mine: ['vehicle-damages', 'mine'] as const,
};
